const ITEMS = ["Members only", "Fan — $50", "Private photo sets", "VIP — $100", "Direct messages", "Inner Circle — $250", "Videos", "Tips & comments"];

const Row = ({ hidden }) => (
  <div className="flex shrink-0 items-center" aria-hidden={hidden}>
    {ITEMS.map((t, i) => (
      <span key={i} className="flex items-center">
        <span className={`px-8 font-display text-3xl sm:text-5xl whitespace-nowrap ${i % 2 ? "italic text-[#D7263D]" : "text-[#0E1B3D]"}`}>{t}</span>
        <span className="text-[#D7263D] text-xl">★</span>
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <section data-testid="editorial-marquee" className="relative border-y border-[#0E1B3D]/[0.08] py-8 sm:py-10 overflow-hidden bg-[#CDEBFB]">
    <div className="marquee-track flex w-max">
      <Row />
      <Row hidden />
    </div>
  </section>
);
